import { createContext } from 'react';

var CollapseContext = createContext({});

export { CollapseContext };
//# sourceMappingURL=CollapseContext.js.map
